module.exports = __webpack_public_path__ + "img/img.c01864a7.png";